import { render, staticRenderFns } from "./InboxEmailCompose.vue?vue&type=template&id=a0580c7c&"
import script from "./InboxEmailCompose.vue?vue&type=script&lang=js&"
export * from "./InboxEmailCompose.vue?vue&type=script&lang=js&"
import style0 from "./InboxEmailCompose.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports